import { FilterSizingType } from '../base/entities/filter-sizing-type';
import { FilterType } from '../base/entities/filter-type';
import { QueryPartData } from '../base/entities/query-part-data.entity';
import { QueryPartStrategy } from '../base/entities/query-part-strategy';
import { QueryPart } from '../base/entities/query-part.class';
import { IFilterData } from './filter-data.entity';
import { FilterHelper } from './filter.helper';

type requiredProperties = 'field' | 'filterType';
export abstract class Filter {
    private filter: IFilterData;

    sizing!: FilterSizingType;
    removable!: boolean;

    private readonly defaults: Omit<IFilterData, requiredProperties> = {
        label: '',
        values: [],
        strategy: QueryPartStrategy.MatchAll
    };

    constructor(filter: Pick<IFilterData, requiredProperties> & Partial<IFilterData>) {
        this.filter = { ...this.defaults, ...filter };
    }

    get filterData(): IFilterData {
        return this.filter;
    }

    get field(): string {
        return this.filter.field;
    }

    get strategy(): QueryPartStrategy {
        return this.filter.strategy;
    }

    set strategy(strategy: QueryPartStrategy) {
        this.filter = {
            ...this.filter,
            strategy
        };
    }

    get filterType(): FilterType {
        return this.filter.filterType;
    }

    get label(): string {
        return this.filter.label;
    }

    set label(label: string) {
        this.filter = {
            ...this.filter,
            label
        };
    }

    get values(): string[] {
        return this.filter.values;
    }

    set values(values: string[]) {
        this.filter = {
            ...this.filter,
            values
        };
    }

    loadQueryPart(queryPart: QueryPartData): void {
        this.filter = FilterHelper.loadQueryPart(this.filter, queryPart);
    }

    loadValues(values: string[]): void {
        this.filter = FilterHelper.loadValues(this.filter, values);
    }

    addValue(value: string): void {
        this.filter = FilterHelper.addValue(this.filter, value);
    }

    clearValues(): void {
        this.filter = FilterHelper.clearValues(this.filter);
    }

    hasValues(): boolean {
        return FilterHelper.hasValues(this.filter);
    }

    getQueryPart(): QueryPart {
        return FilterHelper.getQueryPart(this.filter);
    }
}
